import { ActiveConfiguration } from '@icc/shared/types';
import { AccessoriesConfiguration } from './accessories-configuration';
import { PriceSegment, DiscountGroups, PricePart } from '@icc/price/b2b';
import { TimeLimitSegment } from '@icc/configurator/types';
import { ActiveAccessory } from '../elements/active-accessory';
import { IConfiguratorsDataService } from '@icc/shared/types';

export class AccessoriesActiveConfiguration implements ActiveConfiguration {
    public static is(configuration): configuration is AccessoriesActiveConfiguration {
        return configuration instanceof AccessoriesActiveConfiguration || !configuration.$version && configuration.type === 'accessory';
    }
    type: 'accessory' = 'accessory';
    Name = '';
    Price = 0;
    ListPrice = 0;
    PriceNoMargin = 0;
    ListPriceNoMargin = 0;
    PriceAfterDiscountsInCurrency = 0;
    ListPriceAfterDiscountsInCurrency = 0;
    PriceBeforePromotions = 0;
    ListPriceBeforePromotions = 0;
    PriceGross = 0;
    ListPriceGross = 0;
    PriceGrossAfterDiscounts = 0;
    ListPriceGrossAfterDiscounts = 0;
    PriceGrossBeforePromotions = 0;
    ListPriceGrossBeforePromotions = 0;
    Quantity = 1;
    Issues: any[] = [];
    PriceSegments: PriceSegment[] = [];
    ListPriceSegments: PriceSegment[] = [];
    PriceSegmentsNoMargin: PriceSegment[] = [];
    ListPriceSegmentsNoMargin: PriceSegment[] = [];
    PriceSegmentsBeforePromotions: PriceSegment[] = [];
    ListPriceSegmentsBeforePromotions: PriceSegment[] = [];
    PriceParts: PricePart[] = [];
    ListPriceParts: PricePart[] = [];
    PricePartsNoMargin: PricePart[] = [];
    ListPricePartsNoMargin: PricePart[] = [];
    PricePartsBeforePromotions: PricePart[] = [];
    ListPricePartsBeforePromotions: PricePart[] = [];
    DiscountGroups: DiscountGroups = {};
    DiscountGroupsNoMargin: DiscountGroups = {};
    Discount = 0;
    ListDiscount = 0;
    timeLimit = 0;
    timeLimitsStack: TimeLimitSegment[] = [];
    Title = '';
    Description = '';
    Attachments = [];
    drawData: any;
    valid: {
        accessories: null | boolean;
    } = {
        accessories: null,
    };
    PriceValid = false;

    Accessories: any[] = [];
    SideAccessories = {
        sizes: {
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
        },
        top: [],
        bottom: [],
        left: [],
        right: [],
    };

    attributes: {
        id: string;
        name: string;
        value: string;
        valueId?: number;
    }[] = [];

    constructor(configuration?, private configuratorsDataService?: IConfiguratorsDataService) {
        if (configuration) {
            if (AccessoriesActiveConfiguration.is(configuration)) {
                for (const propName in configuration) {
                    if (Object.prototype.hasOwnProperty.call(this, propName)) {
                        this[propName] = configuration[propName];
                    }
                }
            } else {
                if (AccessoriesConfiguration.is(configuration) && configuratorsDataService) {
                    this.Name = configuration.name;
                    this.Price = configuration.price;
                    this.ListPrice = configuration.listPrice;
                    this.PriceNoMargin = configuration.priceNoMargin;
                    this.ListPriceNoMargin = configuration.listPriceNoMargin;
                    this.PriceAfterDiscountsInCurrency = configuration.priceAfterDiscountsInCurrency;
                    this.ListPriceAfterDiscountsInCurrency = configuration.listPriceAfterDiscountsInCurrency;
                    this.PriceGross = configuration.priceGross;
                    this.ListPriceGross = configuration.listPriceGross;
                    this.PriceGrossAfterDiscounts = configuration.priceGrossAfterDiscounts;
                    this.ListPriceGrossAfterDiscounts = configuration.listPriceGrossAfterDiscounts;
                    this.Quantity = configuration.quantity;
                    this.PriceSegments = configuration.priceSegments;
                    this.ListPriceSegments = configuration.listPriceSegments;
                    this.PriceSegmentsNoMargin = configuration.priceSegmentsNoMargin;
                    this.ListPriceSegmentsNoMargin = configuration.listPriceSegmentsNoMargin;
                    this.PriceSegmentsBeforePromotions = configuration.priceSegmentsBeforePromotions;
                    this.ListPriceSegmentsBeforePromotions = configuration.listPriceSegmentsBeforePromotions;
                    this.PriceParts = configuration.priceParts;
                    this.ListPriceParts = configuration.listPriceParts;
                    this.PricePartsNoMargin = configuration.pricePartsNoMargin;
                    this.ListPricePartsNoMargin = configuration.listPricePartsNoMargin;
                    this.PricePartsBeforePromotions = configuration.pricePartsBeforePromotions;
                    this.ListPricePartsBeforePromotions = configuration.listPricePartsBeforePromotions;
                    this.DiscountGroups = configuration.discountGroups;
                    this.DiscountGroupsNoMargin = configuration.discountGroupsNoMargin;
                    this.Title = configuration.title;
                    this.Description = configuration.description;
                    this.valid = configuration.valid;
                    this.timeLimit = configuration.timeLimit;
                    this.timeLimitsStack = configuration.timeLimitsStack;
                    this.attributes = configuration.attributes;

                    this.Accessories = configuration.accessories.map(
                        accessory => new ActiveAccessory(accessory, null, configuratorsDataService)
                    );
                    this.SideAccessories.top = configuration.sideAccessories.top.map(
                        accessory => new ActiveAccessory(accessory, 'top', configuratorsDataService)
                    );
                    this.SideAccessories.bottom = configuration.sideAccessories.bottom.map(
                        accessory =>
                            new ActiveAccessory(accessory, 'bottom', configuratorsDataService)
                    );
                    this.SideAccessories.left = configuration.sideAccessories.left.map(
                        accessory =>
                            new ActiveAccessory(accessory, 'left', configuratorsDataService)
                    );
                    this.SideAccessories.right = configuration.sideAccessories.right.map(
                        accessory =>
                            new ActiveAccessory(accessory, 'right', configuratorsDataService)
                    );
                    this.SideAccessories.sizes.top = this.SideAccessories.top.reduce(
                        (prev, accessory) => (prev += accessory.count * accessory.accessory.height),
                        0
                    );
                    this.SideAccessories.sizes.bottom = this.SideAccessories.bottom.reduce(
                        (prev, accessory) => (prev += accessory.count * accessory.accessory.height),
                        0
                    );
                    this.SideAccessories.sizes.left = this.SideAccessories.left.reduce(
                        (prev, accessory) => (prev += accessory.count * accessory.accessory.height),
                        0
                    );
                    this.SideAccessories.sizes.right = this.SideAccessories.right.reduce(
                        (prev, accessory) => (prev += accessory.count * accessory.accessory.height),
                        0
                    );

                    ['top', 'bottom', 'left', 'right'].forEach(side => {
                        this.SideAccessories[side].reduce((prev, cur) => {
                            if (prev) {
                                cur.pos = prev.pos + prev.count * prev.accessory.height;
                            }
                            return cur;
                        }, null);
                    });
                }
            }
        }
        this.configuratorsDataService = null;
    }
}
